<script>
export default {
  name: "ReservationTypeBadge",
  props: {
    reservationTypeId: {
      type: String,
      default: ''
    },
  },
  methods: {
    getBackgroundColor() {
      return this.$constant.zzReservationTypeIdBgColor[this.reservationTypeId] ?? ''
    },
    getText() {
      return this.$constant.zzReservationTypeText[this.reservationTypeId] ?? ''
    },
  },
}
</script>

<template>
  <span
    class="badge font-size-12"
    :style="{
      'background-color': this.getBackgroundColor(),
    }"
  >{{ getText() }}</span>
</template>

<style scoped lang="scss">
.badge {
  padding: 0.4em 0.5em;
}
</style>
